export const GET_SU_USER_START = "GET_SU_USER_START"
export const GET_SU_USER_SUCCESS = "GET_SU_USER_SUCCESS"
export const GET_SU_USER_FAILED = "GET_SU_USER_FAILED"
export const GET_SU_USER_RESET = "GET_SU_USER_RESET"

// Employee Details

export const GET_SU_EMP_START = "GET_SU_EMP_START"
export const GET_SU_EMP_SUCCESS = "GET_SU_EMP_SUCCESS"
export const GET_SU_EMP_FAILED = "GET_SU_EMP_FAILED"
export const GET_SU_EMP_RESET = "GET_SU_EMP_RESET"

//Subscription Status

export const GET_SU_SUBS_START = "GET_SU_SUBS_START"
export const GET_SU_SUBS_SUCCESS = "GET_SU_SUBS_SUCCESS"
export const GET_SU_SUBS_FAILED = "GET_SU_SUBS_FAILED"
export const GET_SU_SUBS_RESET = "GET_SU_SUBS_RESET"

// view subscriptions status for all users

export const GET_SU_SUBS_USERS_START = "GET_SU_SUBS_USERS_START"
export const GET_SU_SUBS_USERS_SUCCESS = "GET_SU_SUBS_USERS_SUCCESS"
export const GET_SU_SUBS_USERS_FAILED = "GET_SU_SUBS_USERS_FAILED"
export const GET_SU_SUBS_USERS_RESET = "GET_SU_SUBS_USERS_RESET"



// Manage LOB :)


